/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import React from "react";
import { useLocation } from "react-router-dom";
import DefaultDashboardLayout from "layouts/dashboard/DefaultDashboardLayout";
import AccountsMovementsDataContent from "components/content/AccountingMovementsDataContent";
import { PatientInterface } from "@malmur-technologies/medicalsystem-shared";

/**
 * Navigation state interface for AccountsMovementsPage.
 * 
 * @interface LocationState
 * @property {string} [accountingId] - Patient accounting ID for filtering movements
 * @property {PatientInterface} [patient] - Patient data for context display
 */
interface LocationState {
  accountingId?: string;
  patient?: PatientInterface;
}

/**
 * Accounting movements and transactions page.
 * Displays detailed financial transaction history for a specific patient account.
 * 
 * Features:
 * - Detailed accounting movements list with dates and amounts
 * - Transaction type filtering (charges, payments, adjustments)
 * - Balance calculation and display
 * - Patient context header
 * - Date range filtering
 * - Export capabilities for statements
 * - Print-ready account statements
 * - Integration with billing encounters and payments
 * 
 * The page receives accountingId and patient data via navigation state
 * from the accounting or patient hub pages.
 * 
 * @returns {JSX.Element} Accounting movements page component
 */
const AccountsMovementsPage: React.FC = () => {
  const { state } = useLocation();
  const { accountingId } = (state as LocationState) || { accountingId: null };
  const { patient } = (state as LocationState) || { patient: null };

  return (
    <DefaultDashboardLayout>
      <AccountsMovementsDataContent accountingId={accountingId || ""} patient={patient} />
    </DefaultDashboardLayout>
  );
};

export default AccountsMovementsPage;

